export default __webpack_public_path__ + "static/media/kampagne_1_hund.d08ad21b.png";